import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  BetStatus,
  getAmountWithCurrency,
  ListItemBox,
  ListItemBoxCell,
  ListItemBoxHeader,
  ListItemBoxRow,
  ListItemBoxText,
  ListItemCont,
  maskName,
  useTranslation,
  ListBoxItemImg,
  ListElemText,
} from '@pascal/pascal-core';
import { candiesByIndex, TranslationKeys } from '../../../enums';

const { convertAmount, exchangeAmountByRate } = require('@pascal/pascal-core');

export const CurrentAndTopWinnersItem = observer(({ betData = [] }) => {
  const t = useTranslation();
  const filteredWinnersData = useMemo(() => {
    return {
      ...betData,
      additionalParams: betData?.additionalParams.filter(
        (additionalParam) => additionalParam.status === BetStatus.Win
      ),
    };
  }, [betData]);

  return (
    <>
      {filteredWinnersData?.additionalParams?.length ? (
        filteredWinnersData?.additionalParams.map((additionalParam) => {
          return (
            <ListItemCont key={`${betData.id}_${additionalParam.candy}`}>
              <ListItemBox>
                <ListItemBoxHeader>
                  <ListItemBoxCell size={'big'}>
                    <ListItemBoxText size={'big'} text={t(TranslationKeys.PlayerId)} />
                  </ListItemBoxCell>
                  <ListItemBoxCell size={'small'}>
                    <ListItemBoxText text={maskName(betData.playerExternalId)} size={'big'} />
                  </ListItemBoxCell>
                </ListItemBoxHeader>
                <ListItemBoxRow>
                  <ListItemBoxCell size={'big'}>
                    <ListItemBoxText size={'big'} text={`${t(TranslationKeys.BetType)}`} />
                  </ListItemBoxCell>
                  <ListItemBoxCell>
                    <ListItemBoxCell size={'small'}>
                      <ListBoxItemImg imageSrc={candiesByIndex[additionalParam.candy]} alt='' />
                      {/*  el.additionalParams.type */}
                    </ListItemBoxCell>
                    x<ListElemText>{additionalParam.odd}</ListElemText>
                  </ListItemBoxCell>
                </ListItemBoxRow>
                <ListItemBoxRow>
                  <ListItemBoxCell size={'big'}>
                    <ListItemBoxText size={'big'} text={t(TranslationKeys.Bet)} />
                  </ListItemBoxCell>
                  <ListItemBoxCell>
                    <ListItemBoxText
                      size={'big'}
                      text={`${
                        betData.freeBetId ? `${t('FREE_BET')}:` : ''
                      } ${getAmountWithCurrency({
                        amount: convertAmount(
                          exchangeAmountByRate({ ...betData, ...additionalParam }).amount
                        ),
                        isShowRealCurrency: true,
                      })}`}
                    />
                  </ListItemBoxCell>
                </ListItemBoxRow>
                <ListItemBoxRow>
                  <ListItemBoxCell size={'big'}>
                    <ListItemBoxText size={'big'} text={t(TranslationKeys.Win)} />
                  </ListItemBoxCell>
                  <ListItemBoxCell>
                    <ListItemBoxText
                      className={'win-color'}
                      size={'big'}
                      text={`${getAmountWithCurrency({
                        amount: convertAmount(
                          exchangeAmountByRate({ ...betData, ...additionalParam }).winAmount
                        ),
                        isShowRealCurrency: true,
                      })}`}
                    />
                  </ListItemBoxCell>
                </ListItemBoxRow>
              </ListItemBox>
            </ListItemCont>
          );
        })
      ) : (
        <></>
      )}
    </>
  );
});
